import { absolutePath } from "./absolutePath";

interface IndexParams {
  filter?: {
    query?: string;
    status?: string;
    with_newsletter_lists?: boolean;
  };
  order?: Partial<Record<"name" | "updated_at", "asc" | "desc">>;
  page?: number;
  per_page?: number;
}

export const forms = {
  create: () => absolutePath("forms"),
  index: (params: IndexParams) => absolutePath("forms", params),
  show: (id: number) => absolutePath(`forms/${id}`),
  update: (id: number) => absolutePath(`forms/${id}`),
  destroy: (id: number) => absolutePath(`forms/${id}`),
  duplicate: (id: number) => absolutePath(`forms/${id}/duplicate`),
};
